import { ReactNode, useState, createContext, useContext, useMemo } from 'react'

type PayloadProcessingStateContextType = {
  payloadProcessing: boolean 
  setPayloadProcessing: (value: boolean) => void
}

const PayloadProcessingStateContext = createContext<PayloadProcessingStateContextType | undefined>(undefined)

export function usePayloadProcessingState() {
  const context = useContext(PayloadProcessingStateContext)
  if (!context) {
    throw new Error('usePayloadProcessingState must be used within a PayloadProcessingStateProvider')
  }
  return context
}

export function PayloadProcessingStateProvider({ children }: { children: ReactNode }) {
  const [payloadProcessingState, setPayloadProcessingState] = useState<boolean>(false)
  const value = useMemo(() => ({
    payloadProcessing: payloadProcessingState,
    setPayloadProcessing: setPayloadProcessingState
  }), [payloadProcessingState]);
  return (
    <PayloadProcessingStateContext.Provider value={value}>
      {children}
    </PayloadProcessingStateContext.Provider>
  )
}
